import { createSlice } from "@reduxjs/toolkit";
import { avatar } from "../../../assets/img";

const initialState = {
  existingCusDetails: null,
  requiredDocsByMandate: [],
  addressesData: null,
  activeStep: 1,
  maritalStatus: null,
  isSpouseAndRefereeProfileModalOpen: null,
  isCitizenshipModalOpen: true,
  isPreviousEmploymentDetailsModalOpen: null,
  isPreviousEmployeeAddressModalOpen: null,
  isEmployerAddressModalOpen: null,
  isAddSignatureModalVisible: null,
  isTermsAndConditionsModalOpen: null,
  nicFrontSideUrl: null,
  nicBackSideUrl: null,
  bothSideSideUrl: null,
  isSupplementaryCardDetailsModalOpen: false,
  isCardLinkInfoModalOpen: false,
  isCardLinkInfoModalAlreadyOpen: false,
  isCribConsentModalVisible: false,
  isCribConsentModalAlreadyOpen: false,
  isCribConsentAllow: false,
  profileImgURL: avatar,
  spouseAndRefereeProfileStep: 1,
};

const consoleReducer = createSlice({
  name: "ConsoleReducer",
  initialState: initialState,
  reducers: {
    clearConsoleStore: () => initialState,
    setActiveStep: (state, { payload }) => {
      state.activeStep = payload;
    },
    setExistingCusDetails: (state, { payload }) => {
      state.existingCusDetails = payload;
    },
    setMandateDos: (state, { payload }) => {
      state.requiredDocsByMandate = payload;
    },
    setMaritalStatus: (state, { payload }) => {
      state.maritalStatus = payload;
    },
    setIsSpouseAndRefereeProfileModalOpen: (state, { payload }) => {
      state.isSpouseAndRefereeProfileModalOpen = payload;
    },
    setIsCitizenshipModalOpen: (state, { payload }) => {
      state.isCitizenshipModalOpen = payload;
    },
    setIsPreviousEmploymentDetailsModalOpen: (state, { payload }) => {
      state.isPreviousEmploymentDetailsModalOpen = payload;
    },
    setIsPreviousEmployeeAddressModalOpen: (state, { payload }) => {
      state.isPreviousEmployeeAddressModalOpen = payload;
    },
    setIsEmployerAddressModalOpen: (state, { payload }) => {
      state.isEmployerAddressModalOpen = payload;
    },
    setIsAddSignatureModalVisible: (state, { payload }) => {
      state.isAddSignatureModalVisible = payload;
    },
    setIsTermsAndConditionsModalOpen: (state, { payload }) => {
      state.isTermsAndConditionsModalOpen = payload;
    },
    setNicFrontSideUrl: (state, { payload }) => {
      state.nicFrontSideUrl = payload;
    },
    setNicBackSideUrl: (state, { payload }) => {
      state.nicBackSideUrl = payload;
    },
    setBothSideSideUrl: (state, { payload }) => {
      state.bothSideSideUrl = payload;
    },
    setIsSupplementaryCardDetailsModalOpen: (state, { payload }) => {
      state.isSupplementaryCardDetailsModalOpen = payload;
    },
    setIsCardLinkInfoModalOpen: (state, { payload }) => {
      state.isCardLinkInfoModalOpen = payload;
      state.isCardLinkInfoModalAlreadyOpen = true;
    },
    setIsCribConsentModalVisible: (state, { payload }) => {
      state.isCribConsentModalVisible = payload.isCribConsentModalVisible;
      state.isCribConsentModalAlreadyOpen = true;
      state.isCribConsentAllow = payload.isCribConsentAllow;
    },
    setProfileImgURL: (state, { payload }) => {
      state.profileImgURL = payload;
    },
    setSpouseAndRefereeProfileStep: (state, { payload }) => {
      state.spouseAndRefereeProfileStep = payload;
    },
  },
});

export default consoleReducer;
